import { ActionCreator, Action, Dispatch } from 'redux'
import { ThunkAction } from 'redux-thunk'
import { IGlnLocatieZoekSelectie } from 'shared/models/IGlnLocatieZoekSelectie'
import { IApplicationState } from '../store'
import GlnService from 'shared/service/GlnService'
import { ILocatieGlnMetKoppelingenModel } from 'shared/models/ILocatieGlnMetKoppelingenModel'
import { IResponseAction } from '../interfaces'

export enum Actions {
  ClearDataRequest = 'ClearDataRequest',
  ClearDataResponse = 'ClearDataResponse',
  GetLocationsRequest = 'GetLocationsRequest',
  GetLocationsResponse = 'GetLocationsResponse',
  GetDataFoutResponseAction = 'GetDataFoutResponseAction',
}

export interface IClearDataRequestAction
  extends Action<Actions.ClearDataRequest> {}
export interface IClearDataResponseAction
  extends IResponseAction<Actions.ClearDataResponse> {
  payload: string
}
export interface IGetLocationsRequestAction
  extends Action<Actions.GetLocationsRequest> {
  payload: IGlnLocatieZoekSelectie
}
export interface IGetLocationsResponseAction
  extends IResponseAction<Actions.GetLocationsResponse> {
  payload: ILocatieGlnMetKoppelingenModel[]
}

export type GlnLocatieZoekActions =
  | IClearDataRequestAction
  | IClearDataResponseAction
  | IGetLocationsRequestAction
  | IGetLocationsResponseAction

export const clearDataActionCreator: ActionCreator<
  ThunkAction<
    Promise<IClearDataResponseAction>,
    IApplicationState,
    null,
    IClearDataResponseAction
  >
> = (message: string) => {
  return async (dispatch: Dispatch, getState) => {
    const requestClearAction: IClearDataRequestAction = {
      type: Actions.ClearDataRequest,
    }
    dispatch(requestClearAction)
    const clearResponse: IClearDataResponseAction = {
      success: true,
      type: Actions.ClearDataResponse,
      payload: message,
    }
    return dispatch(clearResponse)
  }
}

export const getLocationsActionCreator: ActionCreator<
  ThunkAction<
    Promise<IGetLocationsResponseAction>,
    IApplicationState,
    null,
    IGetLocationsResponseAction
  >
> = (selectie: IGlnLocatieZoekSelectie) => {
  return async (dispatch: Dispatch, getState) => {
    const requestDataAction: IGetLocationsRequestAction = {
      type: Actions.GetLocationsRequest,
      payload: selectie,
    }
    dispatch(requestDataAction)
    try {
      const result = await GlnService.SearchCustomerLocationLinks(selectie)

      const response: IGetLocationsResponseAction = {
        success: result.success,
        errorMessage: result.errorMessage,
        payload: result.payLoad,
        type: Actions.GetLocationsResponse,
      }

      if (
        (!result.success && result.errorCode === 404) ||
        (result.success && result.payLoad.length === 0)
      ) {
        response.success = false
        response.errorMessage = 'Geen locaties gevonden'
      }

      return dispatch(response)
    } catch (e) {
      const errorResponse: IGetLocationsResponseAction = {
        success: false,
        errorMessage: e.message,
        payload: null,
        type: Actions.GetLocationsResponse,
      }

      return dispatch(errorResponse)
    }
  }
}
